import { extractMolEvent } from '@moleculeone/draw';
import { Mol } from '@moleculeone/types';
import { V4 } from '@moleculeone/utils';

import { BaseReactionProps } from '../BaseReaction';

import { ReversedProductMap, ReversedSubstratesMap } from './reverseMapping';
import { PRODUCT_CLASS_NAME, SUBSTRATE_CLASS_NAME } from './const';

export interface HoverState {
  type?: string;
  substrateIndex: number | null;
  mapId: number | null;
}

export function buildHoverState(
  props: Partial<BaseReactionProps>,
  { event, ref, alignedSubstrateMols, mapToProduct, mapToSubstrates }: any
): HoverState {
  const { productMol, productMap, substratesMap } = props;

  const result: any = {
    substrateIndex: null,
    mapId: null,
  };

  const productElement = event.target.closest(`.${PRODUCT_CLASS_NAME}`);
  const substrateElement = event.target.closest(`.${SUBSTRATE_CLASS_NAME}`);

  let hoveredMol: Mol;
  let indexToMap: number[];
  let mapToOtherSide: ReversedProductMap | ReversedSubstratesMap;

  if (ref?.current && !ref.current.contains(event.target)) {
    return result;
  }

  if (substrateElement !== null) {
    const substrateIdx = parseInt(substrateElement.getAttribute('data-reagent-idx'), 10) - 1;

    result.substrateIndex = substrateIdx;
    hoveredMol = alignedSubstrateMols[substrateIdx];
    indexToMap = (substratesMap ?? [])[substrateIdx];
    mapToOtherSide = mapToProduct;
  } else if (productElement !== null && productMol && productMap) {
    hoveredMol = productMol;
    indexToMap = productMap;
    mapToOtherSide = mapToSubstrates;
  } else {
    return result;
  }

  const molEvent = extractMolEvent(event);

  if (molEvent && hoveredMol) {
    let smallestDist = Number.POSITIVE_INFINITY;

    for (const [keyString, position] of Object.entries(hoveredMol.positions ?? {})) {
      const key = Number(keyString);
      if (indexToMap[key] == null || mapToOtherSide[indexToMap[key]] == null) {
        continue;
      }

      if (indexToMap[key] && V4.dist(position, molEvent.svgPos) < smallestDist) {
        smallestDist = V4.dist(position, molEvent.svgPos);
        result.mapId = indexToMap[key];
      }
    }
  }

  if (result.substrateIndex == null && result.mapId != null) {
    const substrateLocation = mapToSubstrates[result.mapId];

    if (substrateLocation != null) {
      result.substrateIndex = substrateLocation[0];
    }
  }

  return result;
}
